<script>
	import { createEventDispatcher } from 'svelte';
	import { blurOnEscape } from "../tools.js";

	export let name = "";
	export let parentWidth = 0;
	export let styler;

	const dispatch = createEventDispatcher();

	let textbox, size;
	let styling = "";
	let clslist = [];
	let formatting = "";

	let placeholder = `<span class='placeholder'>Click here to edit the ${name}</span>`;
	let html = placeholder;

	$: {
		size = setFontSize(parentWidth, styler.fontsize);
		styling = `font-size: ${size}px; color: ${styler.txtcolor}; --hl-color: ${styler.hlcolor}`;

		clslist = [...styler.style, styler.typeface.slug, "align-" + styler.align];

		formatting = clslist.join(" ");
	}

	function setFontSize(bw, pct=10) {
		let size = bw * pct / 200;
		return size;
	}

	function handleFocus() {
		if (html && html === placeholder) {
			html = "";
			textbox.focus();
		}

		dispatch("edit", {name});
	}

	function handleBlur() {
		if (html === "") {
			html = placeholder;
		}
	}
</script>

<div class="textbox" id="{name}" bind:this={textbox}>
	<div class="textarea {formatting}" contenteditable=true bind:innerHTML={html} style={styling}
			 on:focus={handleFocus} on:blur={handleBlur} use:blurOnEscape role="textbox">

	</div>
	<div class="boxtag">
		<span>{name}</span>
	</div>
</div>

<style>
	.textbox {
		position: relative;
		width: 100%;
		padding: 1.5%;
		z-index: 100;
	}

	.textbox:focus-within {
		outline: 1px dashed #c39;
	}

	.textbox .textarea {
		outline: none;
		line-height: 1.5;
		padding: 0 0.2ch;
		border-radius: 2px;
		inline-size: 100%;
		overflow-wrap: anywhere;
		hyphens: auto;
	}

	.hilite {
		background-color: var(--hl-color);
	}

	.textbox .boxtag {
		position: absolute;
		display: none;
		bottom: 0;
		right: 0;
		padding: 0.25rem;
		font-size: 0.5rem;
		line-height: 1;
		background-color: #c39;
		color: #fff;
	}

	.align-right + .boxtag {
		left: 0;
		right: initial;
	}

	.textbox:focus-within .boxtag {
		display: block;
	}
</style>
